import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { debounceTime, finalize, switchMap } from 'rxjs/operators';
import { CreateOrEditStockTakeDto, StockTakeServiceProxy, CreateOrUpdateStockTakeInput, CreateOrEditStockTakeDetailDto, CreateOrUpdateStockTakeDetailInput } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { AppSessionService } from '../../../shared/common/session/app-session.service';

@Component({
    selector: 'editStockTakeDetailModal',
    templateUrl: './edit-stock-item-modal.component.html',
    standalone: false,
})
export class EditStockItemModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    stockTakeDetail: CreateOrEditStockTakeDetailDto = new CreateOrEditStockTakeDetailDto();
    scannedQty = 0;
    constructor(
        injector: Injector,
        private _stockTakeServiceProxy: StockTakeServiceProxy,
        private _dateTimeService: DateTimeService
    ) {
        super(injector);
    }

    ngOnInit(): void {}

    show(stockTakeId?: number,productId?: number, ): void {
       
        if (!stockTakeId) {
            this.stockTakeDetail = new CreateOrEditStockTakeDetailDto();
            this.stockTakeDetail.id = stockTakeId;
            this.active = true;
            this.modal.show();
        } else {
           
            this._stockTakeServiceProxy.getStockDetailItem(stockTakeId, productId).subscribe((result) => {
                this.stockTakeDetail = result;
                this.scannedQty = result.physicalQty;
                this.active = true;
                this.modal.show();
            });
        }
    }



    save(): void {
        this.saving = true;
       
        var input = new CreateOrUpdateStockTakeDetailInput();
        input.stockTakeDetail = this.stockTakeDetail;
        this._stockTakeServiceProxy
            .updateStockTakeDetailItemQty(input)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
